module.exports = __webpack_public_path__ + "static/media/icn_hs_payment.08de3201.svg";